import React, { useState } from 'react'

import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import DownloadIcon from '@mui/icons-material/Download'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'

import terminologyService from '../../services/terminology'

const ExportGlossaryButton = ({ buttonProps = {}, sx }) => {
    const [anchorEl, setAnchorEl] = useState(null)

    const handleOpen = (event) => setAnchorEl(event.currentTarget)
    const handleClose = () => setAnchorEl(null)

    return (
        <>
            <Button
                {...buttonProps}
                sx={sx}
                onClick={handleOpen}
                aria-haspopup="menu"
                aria-expanded={Boolean(anchorEl)}
                startIcon={<DownloadIcon />}
                endIcon={<ArrowDropDownIcon />}
            >
                Export Glossary
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem component="a" href={terminologyService.getExportUrl('csv')} onClick={handleClose}>
                    Download as CSV
                </MenuItem>
                <MenuItem component="a" href={terminologyService.getExportUrl('pdf')} onClick={handleClose}>
                    Download as PDF
                </MenuItem>
            </Menu>
        </>
    )
}

export default ExportGlossaryButton
